import React, { useState, memo } from 'react';
import classNames from 'classnames';
import {
  SnbMenuList,
  SnbMenuItemButton,
} from '@components/common/snb/elements';

const SnbMenuItem = ({ menu, depth }) => {
  const { location, checkParentMenu } = $hooks.useRoute();
  const { pathname } = location;

  /* URL path에 따른 Tree Menu의 오픈 여부 */
  const checkIsOpen = (path = '') => {
    const paths = pathname.split('/');
    const menuPath = path?.split('/')?.pop();
    const isCurrentMenu = paths.includes(menuPath);

    return isCurrentMenu;
  };

  /* 현재 메뉴의 Active(활성화) 여부 [현재 화면이 해당 path에 속해있는지 여부] */
  const isActive = checkParentMenu(menu, depth);

  // menu에 children[items] 항목이 있을 경우, Tree menu로 설정
  const isTreeMenu = menu?.items?.length > 0;

  // Tree Menu의 Open 여부
  const [isTreeOpen, setIsTreeOpen] = useState(
    isTreeMenu && checkIsOpen(menu.path),
  );

  return (
    <li
      className={classNames(
        isTreeMenu && 'tree',
        (isTreeOpen || isActive) && 'on',
      )}
    >
      <SnbMenuItemButton
        depth={depth}
        menu={menu}
        isTreeOpen={isTreeOpen}
        toggleTree={() => setIsTreeOpen(!isTreeOpen)}
      />

      {/* 하위 메뉴가 있는 경우, SnbMenuList 재귀 생성 (SnbMenuList: SnbMenuItem의 부모 ) */}
      {menu?.items?.length > 0 && (
        <SnbMenuList depth={depth + 1} menus={menu?.items} />
      )}
    </li>
  );
};

SnbMenuItem.propTypes = {
  menu: $propTypes.object.isRequired,
  depth: $propTypes.number,
};

SnbMenuItem.defaultProps = {
  depth: 1,
};

export default memo(SnbMenuItem);
